import PropTypes from 'prop-types'
import SelectedTalentCard from './SelectedTalentCard'

/**
 * Organism Component: SelectedTalentsList
 * Displays a list of selected talents with remove functionality
 */
const SelectedTalentsList = ({ selectedTalents, onTalentRemove }) => {
  if (selectedTalents.length === 0) {
    return null
  }

  return (
    <div className='mt-4'>
      <h4 className='mb-2 text-sm font-medium text-gray-900'>
        Ausgewählte Talente ({selectedTalents.length})
      </h4>
      <div className='flex flex-row flex-wrap gap-2'>
        {selectedTalents.map((talent) => (
          <SelectedTalentCard
            key={talent.id}
            talent={talent}
            onRemove={onTalentRemove}
          />
        ))}
      </div>
    </div>
  )
}

SelectedTalentsList.propTypes = {
  selectedTalents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    })
  ).isRequired,
  onTalentRemove: PropTypes.func.isRequired
}

export default SelectedTalentsList
